export const APPROVAL_STATUS = Object.freeze({
  REQUESTED: 'requested',
  APPROVED: 'approved',
  REJECTED: 'rejected',
})

export const ROUTINE_STATUS = Object.freeze({
  COMPLETED: 'completed',
})
